import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from './LanguageContext';
interface SlideTitleProps {
  onContinue: () => void;
  jumpToSlide?: (index: number) => void;
}
export function SlideTitle({
  onContinue,
  jumpToSlide
}: SlideTitleProps) {
  const {
    t
  } = useLanguage();
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative" data-id="element-877">
      <div className="z-10 max-w-4xl w-full space-y-8" data-id="element-878">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-879">
          <p className="text-sm md:text-base text-teal-400 font-semibold uppercase tracking-[0.25em]" data-id="element-880">
            {t('Snakker Investor Deck for Lind & Risør', 'Snakker Investorpræsentation for Lind & Risør')}
          </p>
          <h1 className="text-5xl md:text-7xl font-serif text-white" data-id="element-881">
            {t('Focus:', 'Fokus:')} <br data-id="element-882" />
            <span className="text-teal-400" data-id="element-883">
              {t('Healthcare Marketing Optimization', 'Optimering af Healthcare Marketing')}
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/70 font-medium max-w-2xl mx-auto mt-6" data-id="element-884">
            {t('Unlocking significant value through continuous, scalable optimization.', 'Frigørelse af betydelig værdi gennem kontinuerlig, skalerbar optimering.')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="pt-8" data-id="element-885">
          <Button onClick={onContinue} className="px-8 py-4 text-lg" data-id="element-886">
            {t('The Opportunity', 'Muligheden')}
          </Button>
        </motion.div>

        {/* Chapter Menu */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.7
      }} className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-3 max-w-4xl mx-auto" data-id="element-887">
          {[{
          num: '01',
          label: t('The Opportunity', 'Muligheden'),
          idx: 1
        }, {
          num: '02',
          label: t('The Solution', 'Løsningen'),
          idx: 6
        }, {
          num: '03',
          label: t('The Business', 'Forretningen'),
          idx: 14
        }, {
          num: '04',
          label: t('The Ask', 'Investeringen'),
          idx: 18
        }].map(ch => <button key={ch.num} onClick={() => jumpToSlide?.(ch.idx)} className="flex flex-col items-center justify-center p-4 rounded-2xl bg-navy-900/40 border border-teal-400/20 hover:bg-teal-400/10 hover:border-teal-400/50 transition-all group" data-id="element-888">
              <span className="text-teal-400/50 font-serif text-xl group-hover:text-teal-400 transition-colors" data-id="element-889">
                {ch.num}
              </span>
              <span className="text-white/80 text-sm font-medium mt-1 group-hover:text-white transition-colors" data-id="element-890">
                {ch.label}
              </span>
            </button>)}
        </motion.div>
      </div>
    </div>;
}